import { useEffect } from "react";

const OrlandoMiamiRedirect = () => {
  useEffect(() => {
    window.location.replace("/orlandomiami.html");
  }, []);
  return (
    <div data-testid="orlandomiami-redirect" style={{ minHeight: "100vh", background: "#0A1E3F" }} />
  );
};

export default OrlandoMiamiRedirect;
